import Vue from "vue"
import Router from "vue-router"
import Meta from "vue-meta"

// Routes
import routes from "./routes"

import store from '../store'

Vue.use(Router)

// Create a new router
const router = new Router({
    mode: "history",
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }
        if (to.hash) {
            return { selector: to.hash }
        }
        return { x: 0, y: 0 }
    }
})

Vue.use(Meta)

router.beforeEach((to, from, next) => {

    if (to.path.search('recover_confirm') >= 0) {
        return next()
    }

    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ["/login", "/signup", "/recover" ]
    
    const isPublicPage = publicPages.includes(to.path)

    const loggedIn = store.getters["auth/isAuthenticated"]

    if (!isPublicPage && !loggedIn) {
        return next("/login")
    }

    if (isPublicPage && loggedIn) {
        return next("/home")
    }

    next()
})

export default router
